import React from "react";
import { Sparkles } from "lucide-react";

export function Toast({ toast }) {
  const color = toast.type === "error"
    ? "border-red-500/60 text-red-200 shadow-[0_10px_30px_-12px_rgba(0,0,0,0.9),0_0_14px_rgba(239,68,68,0.18)]"
    : "border-purple-500/60 text-purple-200 shadow-[0_10px_30px_-12px_rgba(0,0,0,0.9),0_0_14px_rgba(147,51,234,0.2)]";
  return (
    <div className={`fixed top-5 right-5 z-50 flex items-center gap-3 px-4 py-3 rounded-xl bg-[var(--ag7-glass)] backdrop-blur-lg border ${color} max-w-sm`} data-testid="app-toast">
      <Sparkles className="w-5 h-5 text-purple-400" />
      <div>
        <p className="font-bold text-sm">{toast.title}</p>
        <p className="text-xs text-zinc-300">{toast.description}</p>
      </div>
    </div>
  );
}
